import { Box, Button, Flex, Text, VStack } from "@chakra-ui/react";
import { IconType } from "react-icons";
import { Icon } from "@chakra-ui/react";
import React from "react";
import { LOMA_DARK_TEAL, LOMA_GREEN } from "../constants/colors";

export const ProcessingState = ({
    isCustomAudience,
    username,
    network,
    networkIcons,
    isMounted,
}: {
    isCustomAudience: boolean;
    username: string;
    network: string;
    networkIcons: { [key: string]: IconType };
    isMounted: boolean;
}) => {
    return (
        <VStack spacing={4} align="stretch">
            <Text fontSize="md" color="white" textAlign="center">
                Great! We're analyzing your{" "}
                {isCustomAudience ? "audience" : "social media"} data to
                create your custom platform.
            </Text>

            {/* Show their inputs */}
            <Box
                bg="gray.50"
                borderRadius="md"
                p={4}
                textAlign="center"
            >
                <Text fontSize="sm" color="white" mb={2}>
                    {isCustomAudience ? "Your audience:" : "Your social media:"}
                </Text>
                <Flex align="center" justify="center" gap={2}>
                    {!isCustomAudience && (
                        <Icon
                            as={networkIcons[network]}
                            boxSize={5}
                            color={LOMA_DARK_TEAL}
                        />
                    )}
                    <Text fontWeight="500" color="gray.800">
                        {isCustomAudience ? `"${username}"` : `${username}`}
                    </Text>
                </Flex>
            </Box>

            {/* Loading button */}
            <Button
                size={{ base: "md", md: "lg" }}
                width="full"
                height={{ base: "48px", md: "56px" }}
                bgGradient={`linear(135deg, ${LOMA_GREEN} 0%, ${LOMA_DARK_TEAL} 100%)`}
                color="white"
                borderRadius={{ base: "12px", md: "16px" }}
                fontSize={{ base: "md", md: "lg" }}
                fontWeight="600"
                isLoading={true}
                loadingText={`Analyzing ${isCustomAudience ? "audience" : "social"} info`}
                spinner={
                    isMounted ? (
                        // @ts-ignore
                        <l-chaotic-orbit
                            size="24"
                            speed="1"
                            color="white"
                        />
                    ) : undefined
                }
                _loading={{
                    bgGradient: `linear(135deg, #7BC9CC 0%, #357E81 100%)`,
                    color: "white",
                    _hover: {
                        bgGradient: `linear(135deg, #7BC9CC 0%, #357E81 100%)`,
                    }
                }}
            >
                Build My Platform ✨
            </Button>
        </VStack>
    )
}

export default ProcessingState;